module.exports = __webpack_public_path__ + "img/carousel-productos-9.63caa41f.jpg";